import mutations from './mutations.js'
import actions from './actions.js'
import getters from './getters.js'

export default {
  namespaced: true,
  state() {
    return {
      user: {
        id: localStorage.getItem('Bro_erp_User_Id'),
        token: localStorage.getItem('Bro_erp_Token'),
        usertype: localStorage.getItem('Bro_erp_User_Type'),
        name: localStorage.getItem('Bro_erp_User_name'),
        image: localStorage.getItem('Bro_erp_userImg'),
        phone: localStorage.getItem('Bro_erp_userPhone'),
      },
    }
  },
  mutations,
  actions,
  getters,
}
